/**
 * Module: PayoutRow
 * Role: Label/value row for payout details in TerminalSheet split-payout variant.
 * Uses: tokens (S, T)
 * Used by: TerminalSheet (done-split variant)
 *
 * Design ref: ai/designs/miniapp/project/pantene-flow.jsx PayoutRow (L1856-1864)
 */

import { S, T } from '../../../styles/tokens';

interface PayoutRowProps {
  label: string;
  value: string;
}

export function PayoutRow({ label, value }: PayoutRowProps) {
  return (
    <div style={{
      display: 'flex', justifyContent: 'space-between',
      font: T.caption, color: S.secondaryLabel,
    }}>
      <span>{label}</span>
      <span style={{ color: S.label, fontWeight: 600 }}>{value}</span>
    </div>
  );
}
